module.exports = __webpack_public_path__ + "static/media/arrows.12c13536.svg";